import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import type StoreService from 'scaleflow/services/store';

class OperationsTeamsTeamGoalsRoute extends Route {
  @service declare store: StoreService;

  beforeModel() {
    return this.store.findAll('goal');
  }
  model() {
    const team = this.modelFor('operations.teams.team');
    return team;
  }
}

export default instrumentRoutePerformance(OperationsTeamsTeamGoalsRoute);
